export enum ConnectionSource {
  school = 'school',
  game = 'game'
}

export enum ConnectionType {
  user = 'user',
  ges = 'ges'
}
